<div class="{{className}}">
  <ngx-dropzone accept=".pdf,.doc,.docx" (change)="onSelect($event)">
    <ngx-dropzone-label>Drop File Here</ngx-dropzone-label>
    <ngx-dropzone-preview *ngFor="let f of files" [removable]="true" (removed)="onRemove(f)">
        <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label>
    </ngx-dropzone-preview>
  </ngx-dropzone>

</div>
